import gql from "graphql-tag";

export const RELEASE_PAYMENT = gql`
  mutation ($transactionSerialNo: String!) {
    releasePayment(
      releasePaymentInput: { transactionSerialNo: $transactionSerialNo }
    ) {
      paymentRef
      response
      message
      status
    }
  }
`;
